const navbar = {
  navNode: null,
  navToggleNode: null,
  navDropdownToggleNodes: null,
  isHome: false,
  langBtn: null,

  init() {
    this.navNode = document.querySelector('.js-navbar');

    if(this.navNode) {
      this.navToggleNode = this.navNode.querySelector('.js-navbar-toggle');
      this.navDropdownToggleNodes = Array.from(this.navNode.querySelectorAll('.js-navbar-dropdown'));
      this.isHome = document.body.classList.contains('template-home');
      this.langBtn = this.navNode.querySelector('.js-navbar-langs');
      this.initEvents();
    }
  },

  initEvents() {
    if(this.navToggleNode) {
      this.navToggleNode.addEventListener('click', () => {
        this.navNode.classList.toggle('is-open');
      }, false);
    }

    if(this.navDropdownToggleNodes) {
      this.navDropdownToggleNodes.forEach(el => el.addEventListener('click', (e) => {
        const target = e.target;
        target.parentElement.classList.toggle('is-open');
      }, false));
    }

    if(this.langBtn) {
      this.langBtn.addEventListener('click', (e) => {
        e.target.parentNode.classList.toggle('is-open')
      }, false);
    }
  },

  getScrollPosition() {
    return window.pageYOffset || document.documentElement.scrollTop;
  },
};

export default navbar;



// WEBPACK FOOTER //
// ./scripts/modules/navbar.js